import { render } from "./FPluginBlock.vue?vue&type=template&id=4ee17706&scoped=true"
import script from "./FPluginBlock.vue?vue&type=script&lang=js"
export * from "./FPluginBlock.vue?vue&type=script&lang=js"

import "./FPluginBlock.vue?vue&type=style&index=0&id=4ee17706&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee17706"]])

export default __exports__